import React from "react";
import { Card } from "./ui/card.jsx";
import { AnimatedSection } from "./IntersectionObserver.tsx";

const Testimonial: React.FC = () => {
  return (
    <section className="testimonial-section pad-xlarge">
      <div className="dark-container">
        <AnimatedSection>
          <Card className="testimonial-card">
            <div className="testimonial-content">
              <blockquote className="display-medium testimonial-quote">
                " Наша миссия — создавать индивидуальные онлайн-бутики, которые сохраняют ДНК бренда и объединяют премиальный дизайн с современными технологиями, аналитикой и возможностями роста."
              </blockquote>

              <div className="testimonial-author">
                <div className="author-avatar">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_contact-connect-7/artifacts/n0a2t6rc_photo_2024-07-04_12-39-55.jpg" 
                    alt="Андрей Король - CEO, Founder AGK Commerce"
                    className="avatar-image"
                  />
                </div>
                <div className="author-info">
                  <h4 className="heading-3">Андрей Король</h4>
                  <p className="body-small author-title">CEO, Founder</p>
                </div>
              </div>
            </div>


          </Card>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Testimonial;